module.exports = __webpack_public_path__ + "img/icon-logout-enable.f400612b.svg";